import React, { Component } from 'react'


import Avatar from '../../atoms/Avatar'
import ActionBtnIcon from '../../molecules/ActionBtnIcon'

import { dateTimeFormat } from '../../../libraries/Formatter'

import style from './style.css'

export default class Comment extends Component {
    render() {
        let data = this.props.data
        return (
            <div>
                <div className={style.header}>
                    <div className={style.avatar}>
                        <a href={`/${data.user_uri}`}>
                            <Avatar size={30} img={data.user_avatar} />
                        </a>
                    </div>
                    <div className={style.name}>
                        {data.user_name}
                        <br />
                        {data.date && (
                            <div className={style.time}>
                                {dateTimeFormat('d/m/y h:i', data.date)}
                            </div>
                        )}
                    </div>
                    {data.is_admin && (
                        <div className={style.adminAction}>
                            <div className={style.iconAction}>
                                <ActionBtnIcon size='30' icon='trash' theme='light' action={() => { this.props.handleDelete() }} />
                            </div>
                        </div>
                    )}
                </div>

                <div className={style.content}>
                    {data.content}
                </div>
                <div className={style.children}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/molecules-v2/Comment/index.js